export default "https://cdn-static.gokick.com/assets/6a734ef49f9399dbf744c5b441c6b52a80c19f9a/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";